<div class="page-container">
  <div class="public-card">
    <p-card class="card">
      @if (logo) {
        <div class="align-center">
          <img [priority]="true" alt="" class="public-logo img-width100" height="76" ngSrc="assets/images/{{logo}}" width="286"/>
        </div>
      }
      <div class="page-container">
        @if (verifyPath) {
          <div>
            <h2>Link Account</h2>
            <p>Please provide the following so your account may be appropriately linked. Many thanks.</p>
            <form [formGroup]="mainForm" class="user-registration-form">
              <div class="p-grid p-fluid">
                <div class="col-md-4 col-sm-12 col-xs-12">
                  <div class="p-fieldset-content p-mt-2">
                    <label>Date Of Birth<sup class="req">*</sup></label>
                    <app-universal-date-picker (emitData)="mainForm.get('dateOfBirth').setValue($event)" [selectedValue]="mainForm.get('dateOfBirth').value"></app-universal-date-picker>
                    <!--                    <p-datepicker dateMask  dateFormat="mm/dd/yy" formControlName="dateOfBirth" appendTo="body" placeholder="mm/dd/yyyy" [showIcon]="true"  yearRange="1950:2035"></p-datepicker>-->
                    @if ((mainForm.controls.dateOfBirth.dirty) &&
                    mainForm.controls.dateOfBirth.errors?.required) {
                      <span class="p-error">'Date Of Birth' must be provided</span>
                    }
                  </div>
                  <div class="p-fieldset-content p-mt-2">
                    <label>Postal Code<sup class="req">*</sup></label>
                    <input formControlName="postalCode" pInputText type="text">
                    @if ((mainForm.controls.postalCode.dirty) &&
                    mainForm.controls.postalCode.errors?.required) {
                      <span class="p-error">'Postal Code' must be provided</span>
                    }
                  </div>
                  <div class="p-fieldset-content p-mt-2 mask-container">
                    <label>Mobile Phone #<sup class="req">*</sup></label>
                    <p-inputmask [className]="'form-input no-border'" formControlName="primaryPhoneNumber" mask="(999) 999-9999"
                                 unmask="true"></p-inputmask>
                    @if ((mainForm.controls.primaryPhoneNumber.dirty) &&
                    mainForm.controls.primaryPhoneNumber.errors?.required) {
                      <span class="p-error">'Mobile Phone #' must be provided</span>
                    }
                  </div>
                  <div class="p-fieldset-content p-mt-2">
                    <label>{{ 'Member #'|labelReplace }}</label>
                    <input formControlName="memberNumber" pInputText type="text">
                    <p>(Not Required)</p>
                  </div>
                </div>
              </div>
              <div class="tab-form-buttons p-mt-2">
                @if (!isVerifying) {
                  <p-button (click)="verify()" [className]="'inline-button'" [disabled]="mainForm.invalid || !mainForm.dirty" class="p-button-info p-mr-2" label="Link Account"
                            pTooltip="Link Account" tooltipPosition="bottom"></p-button>
                }
                @if (isVerifying) {
                  <p-button [className]="'inline-button'" [disabled]="true" class="p-button-info p-mr-2" label="Link Account">
                    <i class="pi pi-spin pi-spinner save-spinner"></i>
                  </p-button>
                }
              </div>
            </form>
          </div>
        }
        @if (unlinkedPath) {
          <div>
            <h2>More Details Needed</h2>
            <p>We're close, but have one additional request. Please provide the following so your account may be appropriately linked.</p>
            <form [formGroup]="mainFormUnlinked" class="user-registration-form">
              <div class="p-grid p-fluid">
                <div class="col-md-4 col-sm-12 col-xs-12">
                  <div class="p-fieldset-content p-mt-2">
                    <label>First Name<sup class="req">*</sup></label>
                    <input formControlName="firstName" pInputText type="text">
                    @if ((mainFormUnlinked.controls.firstName.dirty) &&
                    mainFormUnlinked.controls.firstName.errors?.required) {
                      <span class="p-error">'First Name' must be provided</span>
                    }
                  </div>
                  <div class="p-fieldset-content p-mt-2">
                    <label>Last Name<sup class="req">*</sup></label>
                    <input formControlName="lastName" pInputText type="text">
                    @if ((mainFormUnlinked.controls.lastName.dirty) &&
                    mainFormUnlinked.controls.lastName.errors?.required) {
                      <span class="p-error">'Last Name' must be provided</span>
                    }
                  </div>
                  <div class="p-fieldset-content p-mt-2">
                    <app-select (emitData)="setOrganizationData($event)" [inputObj]="inputObjOrganization" class="full-width">
                    </app-select>
                  </div>
                  <div class="p-fieldset-content tab-form-buttons p-mt-2">
                    @if (!isVerifying) {
                      <p-button (click)="attemptToLink()" [className]="'inline-button'" [disabled]="mainFormUnlinked.invalid || !mainFormUnlinked.dirty" class="p-button-info p-mr-2" label="Submit"
                                pTooltip="Submit" tooltipPosition="bottom"></p-button>
                    }
                    @if (isVerifying) {
                      <p-button [className]="'inline-button'" [disabled]="true" class="p-button-info p-mr-2" label="Submit">
                        <i class="pi pi-spin pi-spinner save-spinner"></i>
                      </p-button>
                    }
                  </div>
                </div>
              </div>
            </form>
          </div>
        }
      </div>
    </p-card>
  </div>
  <p-toast [baseZIndex]="16000"></p-toast>
</div>
